import { Card } from '../../Card';

export type RateInfoItemType = {
  isLoading: boolean;
  isCurrentProvider: boolean;
  label: string;
  rate: string | undefined;
};

export const RateInfoItem = ({ isLoading, label, rate, isCurrentProvider }: RateInfoItemType) => {
  return (!isLoading && rate) || isCurrentProvider ? (
    <Card.Info isLoading={isLoading} label={label}>
      {rate}
    </Card.Info>
  ) : null;
};
